import { faComments, faHistory } from '@fortawesome/pro-light-svg-icons'

import { EntityActivityContainer } from '@domain-group/suit-theme'

import ConversationContainer from '@components/ConversationContainer'

import Activity from './Activity'

import defaultRequestOptions from './defaultRequestOptions'

export const requestOptions = {
  activity: {
    ...defaultRequestOptions.activity,
  },
  conversation: {
    ...defaultRequestOptions.comment,
    ...defaultRequestOptions.conversation,
    ...defaultRequestOptions.image,
    ...defaultRequestOptions.user,
  },
}

interface EntityActivityProps {
  boxProps?: object,
  componentSettings?: {
    [key: string]: object,
  },
  subjectId: number,
  subjectType: string,
}

const EntityActivity = (props: EntityActivityProps) => {
  const {
    boxProps,
    componentSettings = {},
    subjectId,
    subjectType,
  } = props

  return (
    <EntityActivityContainer
      boxProps={{
        minHeight: 500,
        id: 'realhub-nav-activities',
        marginBottom: 'large',
        ...boxProps,
      }}
      components={{
        activity: {
          icon: faHistory,
          label: 'Activity',
          render: (params: any) => (
            <Activity
              requestOptions={requestOptions.activity}
              {...params}
            />
          ),
        },
        conversation: {
          icon: faComments,
          label: 'Conversation',
          render: (params: any) => {
            const settings = componentSettings.conversation || {}
            const initConversation = {
              subject_id: subjectId,
              subject_type: subjectType,
              // @ts-expect-error TS2339
              title: settings.title,
            }

            return (
              <ConversationContainer
                conversation={initConversation}
                requestOptions={requestOptions.conversation}
                {...params}
              />
            )
          },
        },
      }}
      defaultSelectedComponentKey="activity"
      subjectType={subjectType}
      subjectId={subjectId}
    />
  )
}

EntityActivity.Activity = Activity
EntityActivity.requestOptions = requestOptions

export default EntityActivity
